import type { Theme } from './light'

/**
 * Standard-Dark-Theme
 * Dunkles Theme mit angepassten Farben für besseren Kontrast
 */
export const darkTheme: Theme = {
  name: 'dark',
  colors: {
    // Primärfarben
    primary: '#4dabf7',
    primaryLight: '#1c7ed6',
    primaryDark: '#74c0fc',
    
    // Sekundärfarben
    secondary: '#868e96',
    secondaryDark: '#495057',
    
    // Status-Farben
    success: '#51cf66',
    danger: '#ff6b6b',
    warning: '#ffd43b',
    info: '#4dabf7',
    
    // Hintergrundfarben
    background: '#1d1d1b', // Geändert gemäß UI-Styleguide
    backgroundLight: '#2a2a2a',
    backgroundSecondary: '#2a2a2a',
    backgroundTertiary: '#252523', // Nur minimal heller als background (#1d1d1b)
    backgroundDark: '#0f0f0f',
    surface: '#2a2a2a',
    
    // Textfarben
    text: '#ffffff', // Geändert gemäß UI-Styleguide
    textLight: '#c2f1eb', // Geändert gemäß UI-Styleguide
    textDark: '#f8f9fa',
    textOnPrimary: '#1a1a1a',
    
    // UI-Elemente
    border: '#57747a', // Geändert gemäß UI-Styleguide
    hover: '#343a40',
    focus: 'rgba(77, 171, 247, 0.25)',
    
    // Schatten
    shadowColor: 'rgba(0, 0, 0, 0.5)',
  },
  
  // Schatten-Definitionen
  shadows: {
    sm: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.3)',
    md: '0 0.5rem 1rem rgba(0, 0, 0, 0.4)',
    lg: '0 1rem 3rem rgba(0, 0, 0, 0.5)',
  },
  
  // Weitere Theme-spezifische Eigenschaften
  properties: {
    headerHeight: '60px',
    sidebarWidth: '250px',
    borderRadius: {
      sm: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
    },
    transitions: {
      fast: '150ms ease-in-out',
      normal: '300ms ease-in-out',
      slow: '500ms ease-in-out',
    },
    fonts: {
      family: '"Inter", "Roboto", "Helvetica Neue", sans-serif',
      sizes: {
        h1: '2rem', // 32px
        h2: '1.5rem', // 24px
        h3: '1.125rem', // 18px
        body: '1rem', // 16px
        small: '0.875rem', // 14px
      },
      weights: {
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700'
      }
    },
    buttons: {
      primary: {
        background: '#4dabf7',
        text: '#1d1d1b',
        hover: '#74c0fc'
      },
      secondary: {
        background: '#868e96',
        text: '#ffffff',
        hover: '#495057'
      },
      neutral: {
        background: '#57747a',
        text: '#ffffff',
        hover: '#496369'
      },
      success: {
        background: '#51cf66',
        text: '#1d1d1b',
        hover: '#40c057'
      },
      warning: {
        background: '#ffd43b',
        text: '#1d1d1b',
        hover: '#fcc419'
      },
      danger: {
        background: '#ff6b6b',
        text: '#ffffff',
        hover: '#fa5252'
      }
    },
    alerts: {
      info: {
        background: '#2a3c40',
        text: '#c2f1eb',
        icon: '#4dabf7'
      },
      success: {
        background: '#2c3c2d',
        text: '#acd7c8',
        icon: '#51cf66'
      },
      warning: {
        background: '#3c3824',
        text: '#f1e2c1',
        icon: '#ffd43b'
      },
      danger: {
        background: '#3d1512',
        text: '#f6c6b8',
        icon: '#ff6b6b'
      }
    }
  },
}